import m from "../../geodata/es2015/philippinesLow";
window.am4geodata_philippinesLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/philippinesLow.js
// module id = null
// module chunks = 